import { computed } from "@ember/object";
import { withPluginApi } from "discourse/lib/plugin-api";

function initialize(api) {
  api.modifyClass(
    "controller:user-invited.show",
    (Superclass) =>
      class extends Superclass {
        @computed("currentUser.admin", "model.remaining_users")
        get canBulkInvite() {
          return (
            this.currentUser?.admin &&
            (this.model?.remaining_users === undefined ||
              Number(this.model?.remaining_users) > 1)
          );
        }
      }
  );
}

export default {
  name: "extend-invited",
  initialize(container) {
    withPluginApi((api) => initialize(api, container));
  },
};
